import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { inviteCodesApi } from 'src/Services/API';
import { InviteCodeValidationDto } from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';

export const useAcceptInviteCode = (
  options?: UseMutationOptions<InviteCodeValidationDto, unknown, string>
) => {
  const queryClient = useQueryClient();

  return useMutation<InviteCodeValidationDto, unknown, string>(
    'accept-invite-code',
    async (code: string) => {
      const response = await inviteCodesApi.inviteCodesControllerAccept(code);
      return response.data;
    },
    {
      ...options,
      onSettled: (data, error, variables, context) => {
        options?.onSettled?.(data, error, variables, context);
        queryClient.invalidateQueries('fetch-my-pending-invitations');
        queryClient.invalidateQueries('fetch-assets');
      },
      onSuccess: (data: InviteCodeValidationDto, variables: string, context: unknown) => {
        trackEvent('InviteCode', 'accept');
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
